import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function HotRecommend() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在追的人气韩漫</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {hotComics.slice(0, 10).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                  热门
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-white text-xs">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    <span>{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">更新至第{comic.chapters[0].number}话</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}